export default __webpack_public_path__ + "not-overdue-20.png";